import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { NatsStatus, useMessages } from "../../Services/Nats";
import { Uptime } from "./UptimeIndicator";
import { ExchangeUptime } from "./ExchangeUptime";
import { Status, StatusIndicator } from "./StatusIndicator";
import { Divider } from "./Divider";
import { useQuery } from "@tanstack/react-query";
import { useAllAlgosData } from "../../features/lazertrader/contexts/listAlgosContext";
import { useNormalMode } from "../../features/lazertrader/mutations";
import { StatefulDialog } from "../../features/lazertrader/statefulConfirmationDialog";

const DetailedAvailabilityTab = () => {
  const { status } = useMessages();
  const { uptimes } = useAllAlgosData();
  const { mutateAsync: clearEmergencyMode } = useNormalMode();
  const [clearingEmergency, setClearingEmergency] = useState(false);

  const [jepxLtUptime, setJepxLtUptime] = useState<Uptime>();
  const [natsStatusColor, setNatsConnectedStatusColor] = useState<Status>(
    Status.Unknown
  );

  useEffect(() => {
    // lazerhub serialises ExchangeIdentifier as UPPERCASE.
    setJepxLtUptime(uptimes.find((v) => v.exchange == "JEPX"));
  }, [uptimes]);

  const { error } = useQuery({
    queryKey: ["v1/health"],
    refetchInterval: 5000,
  });

  useEffect(() => {
    if (error) {
      console.error(error);
      setJepxLtUptime(undefined);
    }
  }, [error]);

  useEffect(() => {
    switch (status) {
      case NatsStatus.Connected: {
        setNatsConnectedStatusColor(Status.Healthy);
        break;
      }
      case NatsStatus.Reconnecting: {
        setNatsConnectedStatusColor(Status.Warning);
        break;
      }
      case NatsStatus.Disconnected: {
        setNatsConnectedStatusColor(Status.Unhealthy);
        break;
      }
      case NatsStatus.Uninitialized: {
        setNatsConnectedStatusColor(Status.Unknown);
        break;
      }
    }
  }, [status]);

  return (
    <Stack height="35px" sx={{ justifyContent: "center", color: "white" }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <StatusIndicator label="ORDERBOOK" status={natsStatusColor} />

        <Divider />
        <ExchangeUptime
          exchange="jepx"
          uptime={jepxLtUptime}
          onClearEmergency={() => setClearingEmergency(true)}
        />
      </Stack>
      <StatefulDialog
        open={clearingEmergency}
        setOpen={setClearingEmergency}
        displayValues={{
          title: "Clear emergency mode",
          body: "Return JEPX to normal mode? Algos that were stopped will be started again.",
          loading: "Clearing emergency mode...",
          confirm: "Yes",
          cancel: "No",
        }}
        apiRequest={() => clearEmergencyMode()}
      />
    </Stack>
  );
};

export { DetailedAvailabilityTab };
